import React from 'react';

// KPI card row for the CTO Candidates and Firm Pipeline tabs. Same markup and
// inline styles as MetricsBar (which stays Partner/Investor-only); counts and
// click handling are supplied by the caller. A card with no onClick is a
// plain, non-clickable display. `kpi-scroll` turns the row into a single
// swipeable strip on phones (see responsive.css).
export default function KpiCards({ cards, columns }) {
  return (
    <div className="kpi-grid kpi-scroll" style={{
      display: 'grid',
      gridTemplateColumns: `repeat(${columns}, 1fr)`,
      gap: 10,
      margin: '20px 0 16px',
      flexShrink: 0,
    }}>
      {cards.map(c => {
        const clickable = !!c.onClick;
        return (
          <div
            key={c.key} className="kpi-card"
            onClick={clickable ? c.onClick : undefined}
            {...(clickable ? {
              role: 'button', tabIndex: 0,
              onKeyDown: e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); c.onClick(); } },
            } : {})}
            style={{
              background: c.active ? 'var(--bg-hover)' : 'var(--bg-card)',
              border: `1px solid ${c.active ? c.color : 'var(--border)'}`,
              borderRadius: 'var(--radius)',
              padding: '12px 16px',
              position: 'relative', overflow: 'hidden',
              cursor: clickable ? 'pointer' : 'default',
              transition: 'all 0.15s',
            }}
          >
            <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 2, background: c.color }} />
            <div className="kpi-num" style={{ fontFamily: 'Sora, sans-serif', fontSize: 26, fontWeight: 700, color: c.color, lineHeight: 1 }}>
              {c.count}
            </div>
            <div className="kpi-label" style={{ fontSize: 11, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.08em', marginTop: 4, fontWeight: 500 }}>
              {c.label}
            </div>
          </div>
        );
      })}
    </div>
  );
}
